import dynamic from "next/dynamic";
import { HouseRulesAndSafety } from "commonModule/services/common";
import HomeIconForHouseRule from "components/icons-svg/HomeIconForHouseRule";
import { useDisclosure } from "utils/hooks/useDisclosure";
import { Item } from "../ThingsToKnow";
const HouseRulesAndSafetyModal = dynamic(() => import( /* webpackChunkName: "HouseRulesAndSafetyModal" */"./HouseRulesAndSafetyModal"), {
  ssr: false
});
export const HouseRules = ({
  houseRules
}: {
  houseRules?: HouseRulesAndSafety | null;
}) => {
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();

  // Flatten and separate front_page vs non-front_page
  const allRules = Object.values(houseRules || {}).flat();
  const frontPageRules = allRules.filter(r => r.front_page);
  const otherRules = allRules.filter(r => !r.front_page);

  // Combine: front_page rules first, then others
  const orderedRules = [...frontPageRules, ...otherRules];

  // Show first 10
  const visibleRules = orderedRules.slice(0, 10);
  const showMoreAvailable = orderedRules.length > 10;

  // remove leading zeros, remove space before AM/PM, convert AM/PM to lowercase
  const formatTimeInText = (text: string): string => {
    return text.replace(/\b0?(\d{1,2}:\d{2})\s?(AM|PM)/gi, (_, time: string, period: string) => {
      return `${time?.toLowerCase()}${period?.toLowerCase()}`;
    });
  };
  return <div data-sentry-component="HouseRules" data-sentry-source-file="HouseRules.tsx">
      <div className='mb-1 flex items-center gap-2 md:mb-2'>
        <HomeIconForHouseRule data-sentry-element="HomeIconForHouseRule" data-sentry-source-file="HouseRules.tsx" />
        <p className='text-sm font-semibold leading-7 text-brand-dark md:text-base'>
          House rules
        </p>
      </div>

      <div className='block columns-2 pl-3.5 md:columns-1 md:pl-[7px]'>
        {visibleRules.map((rule, index) => <Item key={index} name={formatTimeInText(rule.name)} />)}
      </div>
      {showMoreAvailable && <button onClick={onOpen} className='flex h-6 justify-start bg-white pl-6 text-sm font-semibold text-accent-500 underline md:pl-[7px] md:text-base'>
          Show more
        </button>}

      {isOpen && <HouseRulesAndSafetyModal title='House Rules' isOpen={isOpen} onClose={onClose} houseRulesAndSafety={houseRules} />}
    </div>;
};